export enum SEARCH_KEYS {
    CLASS_GRADES = 'c',
    QUALITY = 'hq',
    FILE_TYPES = 'ft',
    BUNDLE = 'b',
    FOLDER = 'folder',
    FORMAT = 'f',
    LANGUAGES = 'lng',
    LEARNING_YEARS = 'ly',
    MATERIAL_TYPES = 'mt',
    INTERACTIVE_TYPES = 'it',
    OWNED_BY = 'ob',
    PAGE = 'p',
    PREVENT_AUTOSUGGEST = 'pas',
    PRICE = 'prc',
    QUERY = 'query',
    SALE = 'sale',
    SCHOOL_TYPES = 'st',
    SORTING = 's',
    TAGS = 'tg',
    TAXONOMY = 't',
    TOTAL_PAGES = 'tp',
    PRICE_FROM = 'pfrom',
    PRICE_RANGE = 'r',
    PRICE_TO = 'pto'
}

export const QUERY_SEARCH = {
    Q: 'q',
    AUTHOR_FILTER: 'a',
    TEST_SEGMENT: 'test_segment',
    AUTO_SUGGEST: 'auto_suggest',
    INTENT: 'intent',
    REJECT_INDEXER: 'rejectIndexer'
} as const;
